<template>
	<div class="content__controls">
		<div class="content__options-grp">
			<select
				class="content__options-select"
				name="articleType"
				id="articleType"
				v-model="article.articleType"
				@change="requestSave"
				:disabled="disabled"
			>
				<option :value="null" class="it-bold">No type</option>
				<option
					v-for="(type, i) in articleTypes"
					:value="type"
					:key="i"
				>
					{{ type }}
				</option>
			</select>
		</div>
		<div class="content__options-grp">
			<select
				class="content__options-select"
				name="parentArticle"
				id="parentArticle"
				v-model="article.parentArticleId"
				@change="requestSave"
				:disabled="disabled"
			>
				<option :value="null" class="it-bold">No parent</option>
				<option
					v-for="(parent, i) in indexArticles"
					:value="parent.id"
					:key="i"
				>
					{{ parent.title }}
				</option>
			</select>
		</div>
		<div class="content__options-save" @click="openConfirmDialog" v-if="!disabled">
			<span class="fa-solid fa-trash-can"></span>
		</div>
		<div class="content__options-delim"></div>
		<div class="slider">
			<span class="slider__text">{{ article.published ? 'Published' : 'Unpublished' }}</span>
			<div
				class="slider__btn"
				:class="{ 'slider__btn-active': article.published, 'slider__disabled': disabled }"
				@click="togglePublish"
			>
				<div
					class="slider__dot"
					:class="{
						slider__left: !article.published,
						slider__inactive: !article.published,
						slider__right: article.published,
						slider__active: article.published,
					}"
				></div>
			</div>
		</div>
		<div class="content__options-loading" v-if="loading">
			<SpinnerAdmin v-if="loading" />
		</div>

		<ConfirmDialog
			ref="confDialog"
			:message="'Delete article?'"
			@confirmdelete="deleteArticle"
			@refusedelete="$bvModal.hide('confirm-dialog')"
		/>
	</div>
</template>

<script>
import SpinnerAdmin from "../../shared/SpinnerAdmin";
import ConfirmDialog from "../../shared/ConfirmDialog";
import Article from "../../../services/article";

export default {
	name: "ArticleAdminRibbon",
	components: {
		SpinnerAdmin,
		ConfirmDialog,
	},
	props: ["article", "loading", "disabled"],
	methods: {
		requestSave: function () {
			this.$emit("pingsaveineditor");
		},
		togglePublish: function () {
			if(this.disabled) return;
			this.$emit("togglepublish");
		},
		openConfirmDialog: function () {
			this.$refs.confDialog.show();
		},
		deleteArticle: function () {
			this.loading = true;
			Article.instance()
				.deleteArticle(this.article.id)
				.then(() => {
					this.loading = false;
					this.$refs.confDialog.hide();
					this.$store.dispatch("fetchIndexArticles");
					this.$router.push({ path: "/" });
				})
				.catch((error) => {
					this.loading = false;
					this.$refs.confDialog.hide();
					this.$refs.errDialog.show(error);
				});
		},
	},
	computed: {
		articleTypes: function () {
			return this.$store.getters.articleTypes;
		},
		indexArticles: function () {
			return this.$store.getters.indexArticles;
		},
	},
};
</script>

<style scoped>

.content__options-grp {
	margin-right: 2rem;
}
.content__options-label {
	color: var(--textTertiary);
	text-transform: uppercase;
	margin-right: 1rem;
}
.content__options-select {
	color: var(--clr-accent-primary);
	background-color: #fff;
	border: none;
	border-radius: 2px;
	padding: 5px;
	font-weight: bold;
}
.content__options-select option {
	margin-bottom: 15px;
	margin-top: 15px;
}
.content__options-select:hover {
	cursor: pointer;
}
.content__options-select:focus {
	outline: none;
}
.content__options-save {
	color: var(--clr-accent-primary);
	display: flex;
	align-items: center;
}
.content__options-save:hover {
	cursor: pointer;
}
.content__options-delim {
	width: 1px;
	height: 2rem;
	background-color: var(--clr-accent-primary-shade-5);
	margin-left: 3rem;
	margin-right: 3rem;
}
.content__options-loading {
	position: absolute;
	right: 15px;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.slider {
	display: flex;
	align-items: center;
	margin-right: 3rem;
}
.slider__text {
	color: var(--clr-accent-primary);
	margin-right: 1rem;
	width: 9rem;
}
.slider__btn {
	display: flex;
	align-items: center;
	width: 40px;
	height: 14px;
	border-radius: 10px;
	background-color: var(--clr-accent-primary-shade-5);
	transition: background 200ms ease;
}
.slider__btn-active {
	background-color: var(--clr-accent-primary-shade-6);
}
.slider__btn:hover {
	cursor: pointer;
}
.slider__dot {
	width: 20px;
	height: 20px;
	background-color: var(--clr-accent-primary);
	border-radius: 50%;
	transition: transform 200ms ease, background 200ms ease;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
}
.slider__left {
	transform: translateX(0);
}
.slider__right {
	transform: translateX(100%);
}
.slider__active {
	background-image: url("../../../assets/icons/check-white.svg");
	background-repeat: no-repeat;
	background-position: center;
	background-size: 70%;
}
.slider__inactive {
	background-color: #efedfa;
	display: flex;
	align-items: center;
}

.slider__inactive::before {
	content: "!";
	color: #2a00ff;
	display: block;
	width: 100%;
	text-align: center;
}
.slider__disabled {
	opacity: 0.5;
}
.slider__disabled:hover {
	cursor: not-allowed;
}

.it-bold {
	font-style: italic;
	font-weight: bold;
}
</style>